import React from 'react';
import { motion } from 'framer-motion';
import { Button } from '../ui/Button';
import { ArrowDown } from 'lucide-react';
export function Hero() {
  const handleBuyClick = () => {
    const el = document.getElementById('cta-comprar');
    if (el) {
      el.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
    }
  };
  return <section className="relative min-h-[90vh] flex items-center justify-center overflow-hidden px-6 py-24" data-id="element-108">
      {/* Background decorative elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden -z-10" data-id="element-109">
        <div className="absolute top-[-10%] right-[-5%] w-[500px] h-[500px] rounded-full bg-[#E5E0D8]/30 blur-3xl" data-id="element-110" />
        <div className="absolute bottom-[-10%] left-[-10%] w-[600px] h-[600px] rounded-full bg-[#7C8B6F]/10 blur-3xl" data-id="element-111" />
      </div>

      <div className="max-w-3xl mx-auto text-center space-y-10" data-id="element-112">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} data-id="element-113">
          <span className="inline-block px-4 py-1.5 rounded-full bg-[#7C8B6F]/10 text-[#5A6650] text-sm font-medium tracking-wide mb-8 border border-[#7C8B6F]/20" data-id="element-114">
            Edición 1.0 — LATAM
          </span>

          <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif font-medium text-[#2D2A26] leading-[1.15] mb-8" data-id="element-115">
            Cómo manejar la ansiedad durante la abstinencia
          </h1>

          <p className="text-xl md:text-2xl text-[#4D4A46] max-w-xl mx-auto font-light leading-relaxed" data-id="element-116">
            Guía práctica de 30 días para dejar adicciones (en general) sin
            recaer
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2,
        ease: 'easeOut'
      }} className="pt-6 space-y-8" data-id="element-117">
          {/* Mockup del ebook */}
          <div className="max-w-md mx-auto" data-id="element-118">
            <img src="https://cdn.magicpatterns.com/uploads/1AMDmsn2Dv6JaYdPJH8WUD/heylloyd-image-1770241548684.png" alt="Ebook disponible en tablet y móvil - Cómo manejar la ansiedad durante la abstinencia" className="w-full rounded-lg shadow-2xl" data-id="element-119" />
          </div>

          <div className="flex flex-col items-center gap-2" data-id="element-120">
            <motion.button whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} onClick={handleBuyClick} className="inline-flex items-center justify-center gap-2 rounded-lg font-semibold transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-[#FAF8F5] cursor-pointer bg-[#D4915D] text-white hover:bg-[#C4804C] shadow-md hover:shadow-lg focus:ring-[#D4915D]/50 active:bg-[#B5703D] h-14 px-10 text-lg shadow-xl shadow-[#D4915D]/20" data-id="element-121">
              QUIERO EMPEZAR LOS 30 DÍAS
            </motion.button>
            <span className="text-2xl font-bold text-[#D4915D]" data-id="element-122"></span>
          </div>

          <p className="text-base text-[#7D7A76]" data-id="element-123">
            Descarga inmediata • Acceso de por vida
          </p>
        </motion.div>
      </div>

      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 1,
      duration: 1
    }} className="absolute bottom-10 left-1/2 -translate-x-1/2 text-[#8D8A86]" data-id="element-124">
        <ArrowDown className="w-6 h-6 animate-bounce opacity-50" data-id="element-125" />
      </motion.div>
    </section>;
}